import API from "./api";

const StudentNotesService = {
  // Get all topics accessible to student
  getTopics: async () => {
    try {
      const response = await API.get("/student/notes/topics");
      return response.data;
    } catch (error) {
      console.error("Error fetching notes topics:", error);
      throw error;
    }
  },

  // Get single topic with all content
  getTopic: async (slug) => {
    try {
      const response = await API.get(`/student/notes/topics/${slug}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching topic:", error);
      throw error;
    }
  },

  // Mark topic as completed
  markCompleted: async (topicId) => {
    try {
      const response = await API.post("/student/notes/complete", {
        topic_id: topicId,
      });
      return response.data;
    } catch (error) {
      console.error("Error marking topic as completed:", error);
      throw error;
    }
  },

  // Mark topic as incomplete
  markIncomplete: async (topicId) => {
    try {
      const response = await API.post("/student/notes/incomplete", {
        topic_id: topicId,
      });
      return response.data;
    } catch (error) {
      console.error("Error marking topic as incomplete:", error);
      throw error;
    }
  },
  // Add to existing StudentNotesService object

  // Get all topics in the same folder (for navigation)
  getSiblingTopics: async (topicId, parentId) => {
    try {
      const response = await API.get(`/student/notes/siblings/${topicId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching sibling topics:", error);
      throw error;
    }
  },

  // Get next/previous topic in the same folder
  getTopicNavigation: async (topicId, direction) => {
    try {
      const response = await API.get(
        `/student/notes/navigate/${topicId}?direction=${direction}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching navigation:", error);
      throw error;
    }
  },
};

export default StudentNotesService;
